import React, { Component, Fragment } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import clsx from "clsx";

import { withTheme, withStyles, Tabs, Tab, Box, Modal, IconButton } from "@material-ui/core";

import { ProgressOrError, formatMessageWithValues, Helmet, withModulesManager, journalize } from "@openimis/fe-core";
import CloseIcon from "@material-ui/icons/Close";

import QRCodeGenerator from "./QRCodeGenerator";
import Formslist from "./Formslist";
import { initiateQADetail } from "../actions";
import { approveOrQADetail, startOrStopQA } from "../actions";
import UsersPanel from "./UsersPanel";
import QualityAssuranceMasterPanel from "./QualityAssuranceMasterPanel";
import {
  DETAIL_IN_REVIEW,
  DETAIL_CONFIRMED,
  DETAIL_FORM_DEPLOYED,
  DETAIL_DATA_COLLECTION_IN_PROGRESS,
} from "../constants";
import QualityAssuranceDataView from "./QualityAssuranceDataView";

const HF_FORM_CONTRIBUTION_KEY = "location.HealthFacility";

const styles = (theme) => ({
  page: theme.page,
  lockedPage: theme.page.locked,
  paper: theme.paper.paper,
  modalContent: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "white",
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[5],
    outline: "none",
  },
  modalCloseButton: {
    marginTop: theme.spacing(0),
  },
});

class QualityAssuranceDetailForm extends Component {
  state = {
    selectedTab: 0, // Default tab
    qrCodeModalOpen: false, // State to control QR code modal
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.submittingMutation && !this.props.submittingMutation) {
      this.props.journalize(this.props.mutation);
    }
  }
  handleChange = (event, newValue) => {
    this.setState({ selectedTab: newValue });
  };

  closeModal = () => {
    this.setState({ qrCodeModalOpen: false });
  };
  bulkInitiateAndDeployOdkFormsHandler = (forms) => {
    const { edited } = this.props;
    if (edited && edited.uuid) {
      this.props.initiateAndDeployForms(forms, edited.uuid, "Initiated and deployed Forms");
    }
  };
  renderTabPanel(index, updateAttribute, edited) {
    switch (index) {
      case 0:
        return (
          <Formslist
            uuid={edited?.uuid}
            formType={2}
            detailType="qa"
            accId={edited?.id}
            bulkInitiateAndDeployOdkForms={this.bulkInitiateAndDeployOdkFormsHandler}
          />
        );
      case 1:
        return <UsersPanel detailUuid={edited && edited?.uuid} projectType="qa" projectId={edited && edited?.id} />;
      case 2:
        return <QualityAssuranceDataView edited={edited} detailType="qa" />;
      default:
        return null;
    }
  }

  renderQRCodeModal() {
    const { qrCodeModalOpen } = this.state;
    const { classes } = this.props;

    return (
      <Modal open={qrCodeModalOpen} onClose={this.closeModal}>
        <div className={classes.modalContent}>
          <QRCodeGenerator value={"example.com"} size={300} />
          <div style={{ position: "absolute", top: 0, right: 0 }}>
            <IconButton
              onClick={this.closeModal}
              variant="contained"
              color="primary"
              className={classes.modalCloseButton}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>
      </Modal>
    );
  }

  initiateQADetail = () => {
    const { edited } = this.props;
    if (edited && edited?.uuid) {
      this.props.initiateQADetail(edited?.uuid, "Initiated Quality Assurance Detail");
    }
  };

  handleApproveOrRejectQADetail = (state, clientMutationLabel) => {
    const { edited } = this.props;
    if (edited && edited?.uuid) {
      this.props.approveOrQADetail(edited?.uuid, state, clientMutationLabel);
    }
  };

  startOrStopQa = (action) => {
    const { edited, startOrStopQA } = this.props;
    if (edited && edited?.uuid) {
      startOrStopQA(
        { uuid: edited?.uuid, action: action },
        `${action === "start" ? "Started" : "Stopped"} Quality Assurance Process`,
      );
    }
  };

  render() {
    const { classes, intl, edited, updateAttribute, projectUuid } = this.props;
    const { selectedTab } = this.state;
    return (
      <div className={clsx(false && classes.lockedPage)}>
        <Helmet
          title={formatMessageWithValues(intl, "location", "healthFacility.edit.page.title", {
            code: "quality_assurance_and_accreditation",
          })}
        />
        <ProgressOrError progress={false} error={true} />

        <QualityAssuranceMasterPanel
          edited={edited}
          updateAttribute={updateAttribute}
          initiateQADetail={this.initiateQADetail}
          handleApproveOrRejectQADetail={this.handleApproveOrRejectQADetail}
          startOrStopQA={this.startOrStopQa}
        />
        {edited && edited.isInitialized && (
          <Fragment>
            <Tabs
              value={selectedTab}
              onChange={this.handleChange}
              indicatorColor="primary"
              textColor="primary"
              className={classes.paper}
            >
              <Tab label="Assign Forms" />
              <Tab
                label="User"
                disabled={!(edited.state === DETAIL_DATA_COLLECTION_IN_PROGRESS || edited.state >= DETAIL_IN_REVIEW)}
              />
              {<Tab label="Form Data" disabled={edited?.state < DETAIL_IN_REVIEW} />}
            </Tabs>

            <Box>{this.renderTabPanel(selectedTab, updateAttribute, edited)}</Box>

            {this.renderQRCodeModal()}
          </Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  rights: !!state.core && !!state.core.user && !!state.core.user.i_user ? state.core.user.i_user.rights : [],
  mutation: state.quality_assurance_and_accreditation.mutation,
  submittingMutation: state.quality_assurance_and_accreditation.submittingMutation,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ initiateQADetail, approveOrQADetail, journalize, startOrStopQA }, dispatch);
};

export default withModulesManager(
  connect(mapStateToProps, mapDispatchToProps)(injectIntl(withTheme(withStyles(styles)(QualityAssuranceDetailForm)))),
);
